export default {
  submenu: 'Submenú:',
  content: 'Contenido',
  overview: 'Introducción',
  longTermSupport: 'Recursos y competencias',
  skillsAndTalents: 'Habilidades y talento',
  yourMap: 'Tu hoja de ruta',
  motivationAndEmotionalIntelligence: 'Motivación e Inteligencia Emocional',
  alliancesCompromisesAndResources: 'Alianzas, pactos y recursos',
  skillsToStartABusiness: 'Habilidades emprendedoras',
  accountingAndFinance: 'Contabilidad y Finanzas',
  settingUpYourOwnBusiness: 'Poniendo en marcha tu propio negocio',
  accountingBasics: 'Contabilidad básica',
  openingABankAccount: 'Cuentas bancarias',
  businessPlanBasicInformation: 'Plan de empresa: información básica',
  taxes: 'Impuestos',
  legalFormsOfEmployment: 'Formas jurídicas',
  marketingAndSales: 'Marketing y ventas',
  whatAreMyProducts: '¿Cuáles son mis productos?',
  whoAreMyClients: '¿Quiénes son mis clientes?',
  communication: 'Comunicación',
  positioning: 'Posicionamiento',
  sales: 'Ventas',
  uniqueSellingPoints: 'Puntos únicos de venta',
  publicRelations: 'Relaciones Públicas',
  introduction: 'Introducción',
  strategy: 'Estrategia',
  messagesAndTools: 'Mensajes y herramientas',
  digitalPRAndSMRevolution: 'RP Digital y Revolución MS',
  it: 'Tecnologías de la Información',
  cloudVSOnPremises: 'La nube vs. Trabajo local',
  email: 'Email',
  onlineMarketing: 'Marketing Online',
  webshop: 'Comercio electrónico',
  website: 'Página web'
}



// WEBPACK FOOTER //
// ./src/i18n/contentnav/es.js